const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.ADDONS)
const groupMealPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MEAL)
const groupPricesPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.ADDONS, ApiDataModel.PRICES)

export const apiDietAddons = {
	fetchDietAddons: async (
		page: number = 1,
		perPage: number = 25,
		query?: string | undefined,
	): Promise<IApiResponseModel<IDietAddonModel[]>> => {
		const { data, meta } = await apiCommon<IDietAddon[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { name: query }),
		})

		return { data: data.map(d => Addon(d)), meta }
	},
	fetchDietAddonDetails: async (id: number): Promise<IDietAddonDetailsModel> => {
		const { data } = await apiCommon<IDietAddonDetails>(`${groupPrefix}/${id}`, { method: 'GET' })

		return AddonDetails(data)
	},
	createDietAddon: async (payload: IDietAddonCreatePayload): Promise<IDietAddonDetailsModel> => {
		const { data } = await apiCommon<IDietAddonDetails>(`${groupPrefix}`, { method: 'POST', body: payload })

		return AddonDetails(data)
	},
	updateDietAddon: async (payload: IDietAddonUpdatePayload): Promise<IDietAddonDetailsModel> => {
		const { data } = await apiCommon<IDietAddonDetails>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return AddonDetails(data)
	},
	deleteDietAddon: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, { method: 'DELETE' })
	},
	fetchDietAddonMeals: async (
		query: string | undefined,
		filters?: IApiFilters,
		page: number = 1,
		perPage: number = 25,
	): Promise<IApiResponseModel<IDietAddonMealModel[]>> => {
		const { data, meta } = await apiCommon<IDietAddonMeal[]>(`${groupMealPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { name: query, meal_category: 'addon', ...filters }),
		})

		return { data: data.map(d => AddonMeal(d)), meta }
	},
	fetchDietAddonPrices: async (): Promise<IApiResponseModel<IDietAddonDetailsModel[]>> => {
		const { data, meta } = await apiCommon<IDietAddonDetails[]>(`${groupPricesPrefix}`, {
			method: 'GET',
		})

		return { data: data.map(d => AddonDetails(d)), meta }
	},
}
